module.exports = __webpack_public_path__ + "media/customizations/gareybldg/logo-c8392effe59d453dc45fa8e3d357c1a1.png";